__turbopack_context__.v({
  "feedbackText": "QD0RWq_feedbackText",
  "form": "QD0RWq_form",
  "submitButton": "QD0RWq_submitButton",
  "textFieldWrapper": "QD0RWq_textFieldWrapper",
});
